type MetricPoint = { ts: number; value: string }

export const latestMetricValue = (points: MetricPoint[] | undefined) => {
  if (!points?.length) {
    return null
  }

  const latest = points.reduce((a, b) => (b.ts > a.ts ? b : a))
  const value = parseFloat(latest.value)

  return Number.isFinite(value) ? value : null
}
